import React, { useState, useMemo } from "react";
import Select, { MultiValue } from "react-select";
import "./FilterSelect.css";

// Define option type
interface Option {
  value: string;
  label: string;
}

interface DropdownSelectProps {
  placeholder: string;
  options: string[]; // Now an array of strings
  setAppliedFilters: CallableFunction;
}

const FilterSelect: React.FC<DropdownSelectProps> = ({
  placeholder,
  options,
  setAppliedFilters,
}) => {
  const [selectedOptions, setSelectedOptions] = useState<Option[] | null>([]);

  // Convert array of strings to an array of Option objects
  const formattedOptions = useMemo<Option[]>(() => {
    return options.map((key) => ({
      value: key,
      label: key,
    }));
  }, [options]);

  // Handle selection change
  const handleChange = (values: MultiValue<Option>) => {
    setSelectedOptions(values ? [...values] : []);
    setAppliedFilters(values ? values.map((option) => option.value) : []);
  };

  return (
    <div className="dropdownSelectContainer">
      <Select
        options={formattedOptions} // Use dynamically generated options
        isMulti
        isSearchable
        isClearable
        onChange={handleChange}
        value={selectedOptions}
        placeholder={placeholder}
      />
    </div>
  );
};

export default FilterSelect;
